import React from 'react';

const CustomTimeInput = ({ value, onChange, disabled }) => {
  return (
    <div className="w-full bg-white">
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        className="w-full h-12 border-0 border-b-2 border-b-gray-300 rounded-md px-3 text-center bg-slate-50 font-medium text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
      />
    </div>
  );
};

export default CustomTimeInput;
